import http, { endpoints } from '../http';
import { mapAccountSettingsFromDto, mapBranchFromDto, mapBranchFromUserBranchDto } from './helpers';
const efktClient = http.createClient(endpoints.efkt);
export default class BranchesApi {
    /**
     * `GET /api/branches`. Two caveats the caller has to live with: the endpoint is not scoped to
     * the signed-in user, and it returns chain/owner-level accounts alongside real branches with no
     * field to tell them apart. Picking the wrong level fails as a 422 on `POST /api/order`.
     */
    static async searchBranches({ search, page = 1, limit = 20, }) {
        const response = await efktClient.get('/api/branches', {
            params: {
                search: search || undefined,
                page,
                limit,
            },
        });
        return {
            items: response.data.items.map(mapBranchFromDto),
            total: response.data.total,
        };
    }
    /**
     * `GET /Authentication/user/branches`, bare array — the accounts the signed-in user holds a
     * grant on, with `permissions.admin` and the per-branch webshop settings. Fixes `searchBranches`'
     * documented "not scoped to the user" hole, and is the same read `AuthApi.getAuthenticatedUser`
     * folds into the session profile.
     *
     * Not `GET /api/profile/accounts`, which this used to call: that one resolves the caller from an
     * `email` JWT claim booqly's token does not carry, so it 401s, and it returns no permissions or
     * settings either.
     *
     * **A customer whose Owner has not been flipped yet gets an empty array in a 200, not an error.**
     * There is nothing to fall back on, so callers that need the datahub list must treat empty as a
     * miss rather than waiting for a rejection.
     */
    static async getMyBranches() {
        const response = await efktClient.get('/Authentication/user/branches');
        return response.data.map(mapBranchFromUserBranchDto);
    }
    /**
     * `GET /api/account/{accountId}/setting`, policy `Employee.Authenticated`. Returns the full
     * settings row, not just the order-creation flag: `useCanCreateOrder` reads
     * `.isOrderCreationAllowed` off it today, but callers landing here later for other settings
     * fields shouldn't need a second method. No internal-user bypass — the block applies to
     * everyone, Esoft staff included, so callers must not special-case `user.isInternalUser` here.
     * No try/catch — failing open on a request error is the hook's job (`useCanCreateOrder`), not
     * this one's.
     */
    static async getAccountSettings(accountId) {
        const response = await efktClient.get(`/api/account/${encodeURIComponent(accountId)}/setting`);
        return mapAccountSettingsFromDto(response.data);
    }
}
